/**
 * @generated SignedSource<<d5761f9d041438f75f2cec5298b6f08a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditScheduledArchiveAtQuery$variables = {
  workspaceTodoId: string;
};
export type WorkspaceTodoEditScheduledArchiveAtQuery$data = {
  readonly todoWorkspace: {
    readonly scheduledArchiveAt: {
      readonly isoString: string;
      readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
    } | null;
  } | null;
};
export type WorkspaceTodoEditScheduledArchiveAtQuery = {
  response: WorkspaceTodoEditScheduledArchiveAtQuery$data;
  variables: WorkspaceTodoEditScheduledArchiveAtQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceTodoId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceTodoId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditScheduledArchiveAtQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "scheduledArchiveAt",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FormattedDate"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoEditScheduledArchiveAtQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "scheduledArchiveAt",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isDate"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "076c375663b32330b2620d36ee41eae4",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditScheduledArchiveAtQuery",
    "operationKind": "query",
    "text": "query WorkspaceTodoEditScheduledArchiveAtQuery(\n  $workspaceTodoId: ID!\n) {\n  todoWorkspace(id: $workspaceTodoId) {\n    scheduledArchiveAt {\n      isoString\n      ...FormattedDate\n    }\n    id\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "2f34dc8064150e49a02a417f7fac7295";

export default node;
